import API from "./API";

export default class SpecificationDAO {
    static getSpecificationById = async (id) => {
        return await API.request(`/v1/specification/${id}`, "GET");
    }


}